import { forInputDate, forInputDateTimeLocal, format } from "../lib/DateUtils.ts";
import Icons from "../svg/Icons.ts";
import * as Html from "../util/Html.ts";
import * as modal from "../util/modal.ts";
import * as FwDatas from "../FwDatas.ts";
import * as actionMenu from "../widget/action-menu-registry.ts"
import ApiServer from "../ApiServer.ts";
import { getEmojiByType, getSpecialdaysCache, getSpecialDaysCalendarId } from "./common_specialdays.ts";
import * as amplify from "../util/amplify.ts";
import { validate } from "../util/forms.ts";
import { TaskListCache } from "../server/objects/TaskBeans.ts";
import {OS} from "../lib/os.ts"
import { ContactCache } from "../contact/ContactCache.ts";
import { pickFileFromDevice } from "../lib/FileUtils.ts";

actionMenu.register({
  memberpickbirthday(){
    var birthdateInput = this.getAttribute('data-birthdate')
    if(birthdateInput==='$empty'){
      birthdateInput = '';
    }
    return {
      pickdate:{
        date:birthdateInput?new Date(birthdateInput.substring(-1)):new Date(),
        showYear:this.getAttribute('data-birthdatenoyear')!=='true',
        onpickdate:(date:Date|undefined,showYear:boolean)=>{
          const
            birthdayValue = date===undefined?'$empty':forInputDate(date)+'T00:00:00Z',
            birthDateNoYearValue = (!showYear)+'';
          this.setAttribute('data-birthdate',birthdayValue)
          this.setAttribute('data-birthdatenoyear',birthDateNoYearValue)
          var formNode = this.closest('form') as HTMLFormElement;
          if(formNode){
            formNode.birthDate.value=birthdayValue
            formNode.birthDateNoYear.value = birthDateNoYearValue
          }
          if(!date){
            this.innerHTML = '&nbsp;'
          }else if(showYear){
            this.innerHTML = format(date,"LL")
          }else{
            this.innerHTML = format(date,"DM")
          }
        }
      },
      init(){
        var
          date = birthdateInput?new Date(birthdateInput.substring(-1)):undefined,
          showYear = this.getAttribute('data-birthdatenoyear')!=='true';
        if(!date){
          this.innerHTML = '&nbsp;'
        }else if(showYear){
          this.innerHTML = format(date,"LL")
        }else{
          this.innerHTML = format(date,"DM")
        }
      }
    }

  },
  specialdaydate(){
    var
      form = this.closest('form'),
      withYear = form.withYear?form.withYear?.checked:true,
      nodeAction = this;
    return {
      pickdate:{
        date:new Date(form.startDate.value),
        onpickdate(picked){
          nodeAction.textContent = format(picked,withYear?'LL':'DM')
          form.startDate.value = forInputDate(picked)
        }
      }
    }
  },
  async specialdaypicklistmenu(){
    var
      specialDayMetaId = Html.getDomMetaId(this),
      thenode = this;
    return {
      'menu':[
        {
          svg:Icons.ic_switch,
          i18nkey:"actions.change",
          clickFunction(){
            thenode.previousElementSibling.dispatchEvent(new Event('click'))
          }
        },
        {
          svg:Icons.ic_delete,
          i18nkey:"actions.remove",color:"var(--red)",
          clickFunction(){
            ApiServer.evtupdate({
              metaId:specialDayMetaId,
              taskListId:'$empty'
            })
            amplify.publish('eventUpdated')
          }
        }
      ]
    }
  },
  async specialdaypicklist(){
    //TODO find the good one
    var
      specialDayMetaId = Html.getDomMetaId(this),
      currentList = undefined,
      lists = await TaskListCache.need();
    if(lists.length===0){
      return {onclick:()=>{modal.toast({emoji:"🧐",text:"catsystem.nolisthint"})}}
    }
    return {'menu':lists.map(tasklist=>{
      var svgend = currentList?.metaId===tasklist.metaId?Icons.ic_checkmark:undefined
      return {clickFunction(){
        ApiServer.evtupdate("OnlyOne",{
          metaId:specialDayMetaId,
          taskListId:tasklist.metaId
        })
        amplify.publish('eventUpdated')
      },title:tasklist.name,svgend}
    })}

  },
  async specialdaysmenu(){
    const
      metaId = Html.getDomMetaId(this),
      theEvent = getSpecialdaysCache().SpecialDayCache.get(metaId),
      menu = [];
    if(theEvent.eventType==='BIRTHDAY_ACCOUNT'){
      if(FwDatas.getProfile(theEvent.accountId).isEditable){
        menu.push({svg:Icons.ic_edit,onclick:"modaluser|"+theEvent.refPersonId,i18nkey:'actions.editsourcebirthdate'})
      }
    }else if(theEvent.eventType==='BIRTHDAY'){
      await ContactCache.need()
      if(ContactCache.get(theEvent.refPersonId)?.editable){
        menu.push({svg:Icons.ic_edit,onclick:"contactedit|"+theEvent.refPersonId,i18nkey:'actions.editsourcebirthdate'})
      }
    }else{
      if(theEvent.editable){
        menu.push({svg:Icons.ic_edit,onclick:"specialdaysedit",i18nkey:'actions.edit'})
      }
      menu.push({svg:Icons.ic_copy_one,onclick:"specialdayscopy",i18nkey:'actions.copy'})
    }
    if(OS.canShare){
      menu.push({svg:Icons.ic_send,onclick:"eventshare",i18nkey:'actions.share'})
    }
    menu.push({svg:Icons.ic_download,onclick:"eventdownload",i18nkey:'actions.save'})
    if(theEvent.editable && theEvent.eventType!=='BIRTHDAY_ACCOUNT' && theEvent.eventType!=='BIRTHDAY'){
      menu.push({svg:Icons.ic_delete,color:'var(--red)',async clickFunction(){
        if(!await modal.confirmDelete("event.confirm_delete_event_popup")) return;
        ApiServer.evtdelete("All",[metaId])
        getSpecialdaysCache().SpecialDayCache.invalidate()
        amplify.publish("eventDeleted");
      },i18nkey:'actions.delete'})
    }
    return {menu:menu}
  },
  specialdaysmediaedit(){
    const
      pictureNode = this,
      emojiNode = this.querySelector('emoji'),

      menu = [];

    menu.push({svg:Icons.ic_add_image,clickFunction:async ()=>{
      var images = await pickFileFromDevice('image/*',false)
      if(images.length>0){
        emojiNode.innerHTML = '';
        emojiNode.customFiles = images;
        pictureNode.style.backgroundImage = `url('${URL.createObjectURL(images[0])}')`
      }
    },i18nkey:'actions.addpicture'})

    return {
      menu,
      emoji:"🤷 💄 🍽️ 🚗 👕 🩺 📚 ⚡️ 🕹 🍿 🎁 🛒 💊 🏠 🛡 💵 🐶 🏦 💰 ⚽️ 📅 🚉 ✈️ 🏝 💸 🍔 🏧 🧸 ☎️ 📈 👔 💳 👥".split(' '),
      pickemoji(emoji){
        emojiNode.innerHTML = emoji;
        emojiNode.customFiles = [];
        pictureNode.style.backgroundImage = `unset`
      }
    }
  }
})
export async function editMemberBidthday(membersWithoutBirthday){
  const theModal = modal.openDomModal(await import('./modal_members.mustache'),membersWithoutBirthday)
  theModal.addEventListener('submit', (ev)=>{
    ev.preventDefault()
    let modified = false
    theModal.querySelectorAll('[data-birthdate]').forEach((birthdayNode: HTMLElement)=>{
      var
        birthDate = birthdayNode.getAttribute('data-birthdate'),
        noYear = birthdayNode.getAttribute('data-birthdatenoyear')==='true';

      //les noYear sont en 2024
      /*
      if(noYear){
        birthDate = '2024'+birthDate.substring(4)
      }*/
      modified = true
      ApiServer.prfupdate2({
        birthDate:birthDate,
        birthDateNoYear:noYear,
        metaId:birthdayNode.getAttribute('data-fw-meta-id')
      })
    })
    modal.closeDomModal(theModal)
    if(modified){
      amplify.publish('eventCreated')
      amplify.publish('familyUpdated')
    }

  });
}
async function openspecialdayscreate(eventType :"SPECIAL_DAYS"|"ANNIVERSARY"|"BIRTHDAY_CUSTOM"){
  openspecialdayeditmodal({
    recurrencyDescriptor:{recurrency:"YEARLY",recurrencyInterval:1},
    eventType,
    color:{"BIRTHDAY_CUSTOM":"#7986CB","ANNIVERSARY":"#FFB07C","SPECIAL_DAYS":"#66C0C6"}[eventType],
    startDate:new Date(),
    allDay:true,
    withYear:true,
    emoji :getEmojiByType(eventType),
    reminder0:{simple:"MINUTE-0"}
  })
}

export async function openspecialdayeditmodal(event){
  const
    eventType = event.eventType,
    theModal = modal.openDomModal(await import('./specialdays_edit.mustache'), Object.assign({
      pagetitle:{
        "SPECIAL_DAYS":"specialdays.createtradition",
        "ANNIVERSARY":"specialdays.createanniversary",
        "BIRTHDAY_CUSTOM":"specialdays.createbirthday",
      }[eventType],
      titleplaceholder:{
        "SPECIAL_DAYS":"specialdays.createtraditionplaceholder",
        "ANNIVERSARY":"specialdays.createanniversaryplaceholder",
        "BIRTHDAY_CUSTOM":"specialdays.createbirthdayplaceholder",
      }[eventType],
      isAlldayAvailable:eventType==="SPECIAL_DAYS",
      isWithYearAvailable:eventType==="BIRTHDAY_CUSTOM",
      isYearlyMandatory:eventType==="BIRTHDAY_CUSTOM"||eventType==="ANNIVERSARY",
      //FWWEB-1737
      hideRecurrency:eventType==="BIRTHDAY_CUSTOM"||eventType==="ANNIVERSARY"||(eventType==="SPECIAL_DAYS" && event.metaId && event.recurrencyDescriptor.recurrency!=="NONE"),
      startInput:event.allDay?forInputDate(event.startDate):forInputDateTimeLocal(event.startDate),
      startDisplay:format(event.startDate,!event.birthDateNoYear?'LL':'DM'),
      withYear:!event.birthDateNoYear,
      //WARING Object.assign does not copy prototype function, so we copy them here
      reminder0:event.reminder0,
      reminder1:event.reminder1,
      reminder2:event.reminder2,
    },event)),
    form = theModal.querySelector('form') as HTMLFormElement,
    metaId = Html.getDomMetaId(form),
    dateInput = form.querySelector('[name=startDate]') as HTMLInputElement,
    dateDisplayNode = form.querySelector('[data-key="specialdaydate"]') as HTMLInputElement,
    allDayInput = form.querySelector('[name=allDay]') as HTMLInputElement,
    withYearInput = form.querySelector('[name=withYear]') as HTMLInputElement;

    withYearInput?.addEventListener('change',function(){
      dateDisplayNode.textContent = format(new Date(dateInput.value),withYearInput.checked?'LL':'DM')
    })

    allDayInput?.addEventListener('change',function(){
      if(allDayInput.checked){
        var value = dateInput.value
        dateInput.type = "text"
        dateInput.value = value.substring(0,10)
        dateInput.type = "date"
      }else{
        var value = dateInput.value
        dateInput.type = "text"
        dateInput.value = value.substring(0,10)+"T12:00"
        dateInput.type = "datetime-local"
      }
    })

  theModal.addEventListener('submit', function(submitEvent){
    submitEvent.preventDefault();
    if(!validate(form)){
      return false;
    }
    const
      textInput = form.querySelector('[name=text]') as HTMLInputElement,
      //colorInput is added async by the colorpicker widget, so we cannot get it in the upper scope
      colorInput = form.querySelector('[name=color]') as HTMLInputElement,
      emoji = form.querySelector('emoji') as HTMLElement,
      privateInput = form.querySelector('[name=private]') as HTMLInputElement,
      recurrencyInput = form.querySelector('[name=recurrency]') as HTMLInputElement,
      recurrencyIntervalInput = form.querySelector('[name=recurrencyInterval]') as HTMLInputElement,
      recurrencyEndDateInput = form.querySelector('[name=recurrencyEndDate]') as HTMLInputElement,
      byDayInput = form.querySelector('[name=byDay]') as HTMLInputElement,
      byMonthDayInput = form.querySelector('[name=byMonthDay]') as HTMLInputElement,
      isToAllInput = form.querySelector('[name=isToAll]') as HTMLInputElement,
      attendeesSelect = form.querySelector('[name="attendee"]') as HTMLInputElement,
      allDay = allDayInput?(allDayInput.type==='checkbox'?allDayInput.checked:allDayInput.value):true,


      serverInput = {
        metaId,
        calendarId:getSpecialDaysCalendarId(),
        type:event.eventType,
        text:textInput.value,
        startDate:allDay?dateInput.value:new Date(dateInput.value).toISOString(),
        endDate:allDay?dateInput.value:new Date(dateInput.value).toISOString(),
        allDay,
        recurrency:recurrencyInput?recurrencyInput.value:"YEARLY",
        recurrencyInterval:recurrencyIntervalInput?.value,
        recurrencyEndDate:recurrencyEndDateInput?.value,
        byDay:byDayInput?.value,
        byMonthDay:byMonthDayInput?.value,
        birthDateNoYear:withYearInput?!withYearInput.checked:false,
        color:colorInput.value,
        emoji:emoji.innerHTML,
        picture:emoji.innerHTML.length?'$empty':emoji.customFiles,
        private:privateInput?.checked,
        isToAll:isToAllInput?.checked,
        attendee:Array.from(attendeesSelect?.querySelectorAll('option')||[]).map(option=>{return {accountId:option.getAttribute('value')}}),
        reminderList:JSON.parse((form.querySelector('[name=reminderList]') as HTMLInputElement).value)
      }

    if(metaId){
      ApiServer.evtupdate(serverInput)
      getSpecialdaysCache().SpecialDayCache.invalidate()
      amplify.publish('eventUpdated')

    }else{
      ApiServer.evtcreate(serverInput)
      getSpecialdaysCache().SpecialDayCache.invalidate()
      amplify.publish('eventCreated')
    }
    modal.closeDomModal(theModal)
  })

}



Html.registerDom({
  async specialdayscopy(){
    var
      {SpecialDayCache,SpecialDayInstanceCache} = getSpecialdaysCache(),
      original = SpecialDayInstanceCache.get(Html.getDomMetaId(this)),
      master = SpecialDayCache.get(original.eventMasterId),
      copy = Object.assign({}, master,{metaId:null})
    console.log(original.iEvent)
      openspecialdayeditmodal(copy)
  },
  async specialdayscreate(){
    var button = await modal.pick({
      title:"specialdays.picktype",
      cssClass:"large",
      gap:"var(--space-xs)",
      button:[
        {title:"specialdays.birthday"   ,text:"specialdays.birthdaytext",icon:Icons.specialdays.ic_birthday_big,onclick:()=>openspecialdayscreate("BIRTHDAY_CUSTOM")},
        {title:"specialdays.anniversary",text:"specialdays.anniversarytext",icon:Icons.specialdays.ic_anniversary_big,onclick:()=>openspecialdayscreate("ANNIVERSARY")},
        {title:"specialdays.tradition"  ,text:"specialdays.traditiontext",icon:Icons.specialdays.ic_tradition_big,onclick:()=>openspecialdayscreate("SPECIAL_DAYS")}

      ]})
    if(button){
      button.onclick()
    }

  },
  async specialdaysclearplace(){
    ApiServer.evtupdate({
      metaId:Html.getDomMetaId(this),
      placeId:"$empty",
      where:""
    })
    amplify.publish('eventUpdated')
  }
})
